export const const_data = {
  group_max_length: 50,
};
